export enum CompanyRole {
  ADMIN = 'ADMIN',
}
